export default {
  submitText: '生成',
  emptyBtn: false,
  labelWidth: 120,
  column: [
    {
      label: '费用种类',
      prop: 'feeSort',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=fee_sort',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          message: '请选择费用种类',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '扣款银行',
      prop: 'bankId',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          message: '请选择银行类型',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '扣款截至周期',
      prop: 'billcycleNo',
      type: 'month',
      searchRange: true,
      format: 'yyyyMM',
      valueFormat: 'yyyyMM',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: [
        {
          required: true,
          message: '请选择扣款截至周期',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '扣款笔数',
      prop: 'cutNum',
      hide: true,
      disabled: true,
      span: 12,
    },
    {
      label: '扣款总额(元)',
      prop: 'cutAmount',
      hide: true,
      disabled: true,
      span: 12,
    },
    {
      label: '扣款备注',
      prop: 'cutRemark',
      type: 'textarea',
      minRows: 5,
      maxlength: 100,
      span: 24,
      showWordLimit: true,
    },
  ],
};
